import React from 'react';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import StatusIndicator from '@amzn/awsui-components-core/status-indicator';
import type { StarGridText } from 'src/components/star-grid/hooks/useStarGridText';
import type { LookupChecks as LookupChecksData } from 'src/components/star-grid/datasets/utils/lookupChecks';

/** The three ✓/✗ checks for a lookup: a unique key, a full match rate, and an unchanged row count. */
export const LookupChecks: React.FC<{ text: StarGridText; checks: LookupChecksData }> = ({ text, checks }) => (
  <SpaceBetween direction="horizontal" size="s">
    <StatusIndicator type={checks.unique ? 'success' : 'error'}>{text('wizardLookupCheckUnique')}</StatusIndicator>
    <StatusIndicator type={checks.match >= 1 ? 'success' : 'error'}>
      {text('wizardLookupCheckMatch')} {Math.round(checks.match * 100)}%
    </StatusIndicator>
    <StatusIndicator type={checks.rowCountUnchanged ? 'success' : 'error'}>{text('wizardLookupCheckRowCount')}</StatusIndicator>
  </SpaceBetween>
);
